import React, { FC, useRef } from "react";
import useNavigate from "src/hooks/useNavigate";
import { FontAwesomeIcon } from "src/constants/fontAwesomeIcons";
import useSelector from "src/hooks/useSelector";
import { INavItem } from "..";
import ReactTooltip from "react-tooltip";
import "./DrawerItem.scss";

interface IDrawerItemProps {
    navItem: INavItem;
}

const DrawerItem: FC<IDrawerItemProps> = ({ navItem }) => {
    const isOpen = useSelector((state) => state.navigation.isOpen);
    const location = useSelector((state) => state.routing.location.pathname);
    const light = useSelector((state) => state.theme.light);

    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement>(null);

    const handleOnClickEvent: React.MouseEventHandler<HTMLDivElement> = (
        event
    ) => {
        const container = containerRef.current;
        if (container) {
            const ripple = document.createElement("span");
            ripple.className = "ripple";

            const rect = container.getBoundingClientRect();
            const size = Math.max(rect.width, rect.height);
            ripple.style.width = ripple.style.height = `${size * 2}px`;

            const x = event.clientX - rect.left - size;
            const y = event.clientY - rect.top - size;

            ripple.style.left = `${x}px`;
            ripple.style.top = `${y}px`;

            container.appendChild(ripple);

            // Clean up after animation
            setTimeout(() => {
                ripple.remove();
            }, 1400);
        }

        if (navItem.url) {
            navigate(navItem.url);
        }
    };

    const isActive = () => {
        if (
            navItem.url?.toLowerCase() === location?.toLowerCase() &&
            navItem.title !== "Back"
        ) {
            return true;
        }
        // else if (
        //     location?.toLowerCase().includes(navItem.url?.toLowerCase()) &&
        //     navItem.title !== "Back"
        // ) {
        //     return true;
        // }
        return false;
    };

    return (
        <div
            ref={containerRef}
            className="item-container-transition item-container"
            style={{
                backgroundColor: isActive()
                    ? light
                        ? "rgba(234, 234, 234)"
                        : "rgba(255, 255, 255, 0.15)"
                    : "",
            }}
            onClick={handleOnClickEvent}
            data-tip
            data-for={`tooltip-${navItem.title}`}
        >
            {/* Icon */}
            <div className="item-icon">
                <FontAwesomeIcon icon={navItem.icon} fixedWidth />
            </div>

            {/* Title */}
            <div
                className="item-title"
                style={{ display: isOpen ? "block" : "none" }}
            >
                <span className="item-container-title">{navItem.title}</span>
            </div>

            {/* Tooltip */}
            {!isOpen && (
                <ReactTooltip
                    id={`tooltip-${navItem.title}`}
                    place="right"
                    effect="solid"
                    style={{ position: "relative", zIndex: 99999999 }}
                >
                    {navItem.title}
                </ReactTooltip>
            )}
        </div>
    );
};

export default DrawerItem;
